const navLinks = [
  {
    to: "/rmapage",
    label: "RMA",
    roles: ["user"],
  },
  {
    to: "/uploads",
    label: "Uploads",
    roles: ["inventry"],
  },

  {
    to: "/xbmpage",
    label: "XBM",
    roles: ["user"],
  },
  {
    to: "/tradeinpage",
    label: "Trade-IN",
    roles: ["user"],
  },
 
  {
    to: "/register",
    label: "Register",
    roles: ["admin"],
  },
  {
    to: "/registerstore",
    label: "Register Store",
    roles: ["admin"],
  },
  {
    to: "/resetpassword",
    label: "Reset Password",
    roles: ["admin"],
  },
];

export default navLinks;
